import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
// import { IBannerData, IVideoData } from "../exports/interfaces";
// import { fetchArchiveBanner, fetchVideoData } from "../api/ArchiveApi";
import { IBannerData, IVideoData } from "../exports/interfaces";
import { fetchArchiveBanner, fetchVideoData } from "../api/ArchiveApi";
import { dynamicFailed } from "../hooks/useToast";
import ArchiveBanner from "../components/archive/ArchiveBanner";
import ArchiveVideos from "../components/archive/ArchiveVideos";
// import ArchiveVideos from "../components/archive/ArchiveVideos";

const Archive = () => {
  const { setLoading } = useLoader();
  const [archiveBannerData, setArchiveBannerData] = useState<IBannerData[]>([]);
  const [archiveVideoData, setArchiveVideoData] = useState<IVideoData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchArchiveBanner(), fetchVideoData()])
    // Promise.all([fetchArchiveBanner()])
      .then(([archiveBannerData,videoData]) => {
        setArchiveBannerData(archiveBannerData);
        setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <ArchiveBanner archiveBannerData={archiveBannerData} />
      <ArchiveVideos archiveVideoData={archiveVideoData} />
    </>
  );
};

export default Archive;
